<template>
  <MeasurementInput
    v-bind="{label}"
    v-model="modelValue"
    class="WeightInput"
    :minValue="50"
    :maxValue="400"
    :interval="10"
  >
    <template #tick="{ tick }">
      {{ tick }}
    </template>
  </MeasurementInput>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import MeasurementInput from "./MeasurementInput.vue";

const modelValue = defineModel<number | null>({
  required: true,
});

const label = computed(() => {
  if (modelValue.value === null) return;

  return `${modelValue.value} lbs`;
});
</script>
